const prefix = 'component_select_event/'

const type = {
    LOAD_LIST_EVENTS: prefix + 'load_list_event',
    LOAD_LIST_EVENTS_SUCCESS: prefix + 'load_list_event_success',
    UPDATE_TEXT_SEARCH: prefix + 'update_text_search',
    SEARCH_EVENT: prefix + 'search_event',

    UPDATE_SELECT_STATE_EVENT: prefix + 'update_select_state_event',
    UPDATE_SELECTED_EVENT: prefix + 'update_selected_event',

    CHANGE_PAGE_SIZE: prefix + 'change_page_size',
    CHANGE_CURRENT_PAGE: prefix + 'change_current_page',

    UPDATE_STATE: prefix + 'update_state'
}

const action = {
    loadListEvents: params => {
        return {
            type: type.LOAD_LIST_EVENTS,
            payload: {
                params
            }
        }
    },
    loadListEventSuccess: events => {
        return {
            type: type.LOAD_LIST_EVENTS_SUCCESS,
            payload: {
                events
            }
        }
    },
    updateTextSearch: textSearch => {
        return {
            type: type.UPDATE_TEXT_SEARCH,
            payload: {
                textSearch
            }
        }
    },
    searchEvent: () => {
        return {
            type: type.SEARCH_EVENT,
            payload: {

            }
        }
    },
    updateSelectStateEvent: (eid, selectState) => {
        return {
            type: type.UPDATE_SELECT_STATE_EVENT,
            payload: {
                eid,
                selectState
            }
        }
    },
    updateSelectedEvent: events => {
        return {
            type: type.UPDATE_SELECTED_EVENT,
            payload: {
                events
            }
        }
    },
    changePageSize: pageSize => {
        return {
            type: type.CHANGE_PAGE_SIZE,
            payload: {
                pageSize
            }
        }
    },
    changeCurrentPage: pageIndex => {
        return {
            type: type.CHANGE_CURRENT_PAGE,
            payload: {
                pageIndex
            }
        }
    },
    updateState: state => {
        return {
            type: type.UPDATE_STATE,
            payload: {
                state
            }
        }
    }
}

export default {
    type,
    action
}